import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, Flex } from '@lightspeed/flame/Core';
import { themeGet } from '@styled-system/theme-get';

import {
  ANIMATION_DURATION,
  MOVE_OFF_SCREEN_FUNC,
  MOVE_ONTO_SCREEN_FUNC,
  SIDEBAR_WIDTH,
} from '~/renderer/components/Sidebar/Sidebar.style';
import { isWindows } from '~/renderer/utils';

interface Props {
  backgroundImage?: string;
  className?: string;
  backgroundColor?: string;
  isSideBarClosed?: boolean;
}

const sideBarClosedStyles = `
  background-color: white;
  margin-left: 0;
  transition-timing-function: ${MOVE_ONTO_SCREEN_FUNC};
`;
const sideBarOpenStyles = `
  background-color: ${themeGet('colors.gray-50')};
  transition-timing-function: ${MOVE_OFF_SCREEN_FUNC};
  margin-left: ${SIDEBAR_WIDTH};
`;

export const Page = styled(Flex)<Props>`
  box-shadow: ${props =>
    isWindows ? `inset 0px 1px 0px ${themeGet('colors.gray-100')(props)}` : 'none'};
  padding: ${themeGet('space.6')};
  position: relative;
  transition: all;
  transition-duration: ${ANIMATION_DURATION};
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  ${({ backgroundImage }) => (backgroundImage ? `background-image: url(${backgroundImage});` : '')}
  background-size: cover;
  ${({ isSideBarClosed }) =>
    isSideBarClosed
      ? css`
          ${sideBarClosedStyles}
        `
      : css`
          ${sideBarOpenStyles}
        `}
  @media only screen and (min-width: ${themeGet('breakpoints.0')}) {
    height: 100vh;
  }

  &.customer-facing-display {
    @media only screen and (min-width: ${themeGet('breakpoints.0')}) {
      flex-direction: row;
    }
  }
`;

export const PageOverlay = styled(Box)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: hidden;
  pointer-events: none;

  > * {
    pointer-events: auto;
    margin: ${themeGet('space.3')} ${themeGet('space.6')};
  }
`;
